/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Section_AgentInputs */

const en_directory_detail_section_agent = /** @type {(inputs: Directory_Detail_Section_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent readiness`)
};

const zh_directory_detail_section_agent = /** @type {(inputs: Directory_Detail_Section_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 就绪度`)
};

/**
* | output |
* | --- |
* | "Agent readiness" |
*
* @param {Directory_Detail_Section_AgentInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_section_agent = /** @type {((inputs?: Directory_Detail_Section_AgentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Section_AgentInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_section_agent(inputs)
	return zh_directory_detail_section_agent(inputs)
});
export { directory_detail_section_agent as "directory.detail.section.agent" }